import {createEmailHistoryClient} from "../components/EmailHistory/historyContract";
import {readEmailHistoryJson} from "../components/EmailHistory/historyRequest";

// Browser requests remain same-origin and use the existing SWA session cookie.
export const emailHistoryService=createEmailHistoryClient((path,signal)=>readEmailHistoryJson(path,{credentials:"include"},signal));
